/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" */
import { isBrowser } from '@toucan/client/global/nextjs';

/**
 * Polyfills Element.prototype.closest
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
function polyfillElementClosest() {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            // @ts-ignore
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s: string) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let el = this;

            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement || (el.parentNode as Element);
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
}

if (isBrowser()) {
    polyfillElementClosest();
}
